import { hackleClient } from "hackle/hackleInstance";
import { THackleKeys } from "types/hackle";

type THackleEventUtilProps<T> = {
  key: THackleKeys;
  properties?: { [P in keyof T]: T[P] };
};

export const hackleEventUtil = <T>({ key, properties }: THackleEventUtilProps<T>) => {
  const event = {
    key,
    properties,
  };

  hackleClient.track(event as any);
};
